import { render, staticRenderFns } from "./SocialFeedUpdateView.vue?vue&type=template&id=a30ee1c2&"
import script from "./SocialFeedUpdateView.vue?vue&type=script&lang=js&"
export * from "./SocialFeedUpdateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports